// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container--DMPK3"};